export default __webpack_public_path__ + "static/media/frg--orchard-parklands.17d9eb53.png";